import { render, staticRenderFns } from "./AlertTableCell.vue?vue&type=template&id=bbcef57e&scoped=true"
import script from "./AlertTableCell.vue?vue&type=script&lang=js"
export * from "./AlertTableCell.vue?vue&type=script&lang=js"
import style0 from "./AlertTableCell.vue?vue&type=style&index=0&id=bbcef57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcef57e",
  null
  
)

export default component.exports